module.exports = __webpack_public_path__ + "static/media/skf.2603a2e1.svg";